const META_TAGS_SUCCESS = "META_TAGS_SUCCESS";

export { META_TAGS_SUCCESS };